<div class="wrapper">
  <div class="container">
    <h1>Đăng nhập</h1>

    <form class="form" [formGroup]="form" autocomplete="off" *ngIf="form">
      <input type="text" placeholder="Username" formControlName="username">
      <input type="password" placeholder="Password" formControlName="password">
      <button type="submit" id="login-button" (click)="submit()">Login</button>
    </form>
  </div>

  <ul class="bg-bubbles">
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
  </ul>
</div>
